module.exports = __webpack_public_path__ + "static/media/campana.d8da7853.svg";